import { render } from "./your-settings.vue?vue&type=template&id=354fbb1e&lang=pug"
import script from "./your-settings.vue?vue&type=script&lang=js"
export * from "./your-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__